/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import L from "../Lang";
import { Link } from "react-router-dom";

class MyMenu extends BaseCom {
    render() {
        return <div className="container-fluid">
            <h1><L>My Account</L></h1>
            <ul className="list-group">
                <li className="list-group-item"><Link to="info"><L>Personal Information</L></Link></li>
                <li className="list-group-item"><Link to="security"><L>Security</L></Link></li>
            </ul>
        </div>;
    }
}

export default withParamsAndNavigate(MyMenu);